<template>
  <div class="partyActivityList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="gardenId">
            <el-option key :label="$t('lang.lab_chooseGarden')" value=""></el-option>
            <el-option v-for="(item,index) in gardens" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input class="searchInput" v-model="activityName" placeholder="请输入活动标题"></el-input>
        </el-form-item>
        <el-button type="primary" @click="getData">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" style="float:right;margin-bottom:10px;" @click="add">新增活动
        </el-button>
      </div>
      <el-table :data="tableData"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        class="wid100" :row-class-name="tableRowClassName">
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="garden.name" label="小区名称">
        </el-table-column>
        <el-table-column prop="activityName" label="活动标题">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light" v-if="scope.row.activityName&&scope.row.activityName.length>30"
              :disabled="false">
              <div slot="content">
                <span>
                  {{ scope.row.activityName }}
                </span>
              </div>
              <div>
                {{ scope.row.activityName.substring(0, 30) | valueIsNull }}
                <span v-if="scope.row.activityName.length>30">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.activityName | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" sortable width="300px">
          <template slot-scope="scope">
            {{ scope.row.createTime | time }}
          </template>
        </el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')"
          :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deleteOne(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:partyActivityList
   *@Description:党建活动
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  // import {
  //   mapGetters
  // } from 'vuex'
  export default {
    name: '/manage/main.partyActivityList',
    data() {
      return {
        gardens: [], // 园区列表
        gardenId: '', // 选择园区的id（模糊查询）
        activityName: '', // 活动标题（模糊查询）
        tableData: [], // 活动list
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        pageCount: 0, // 总页数
      }
    },
    components: {

    },
    watch: {

    },
    computed: {
      // ...mapGetters(['gardenId'])
    },
    activated() {
      this.getData()
    },
    created() {
      this.selectGarden()
      this.getData()
    },
    methods: {
      selectGarden() {
        this.$get(`/gardens`).then(
          res => {
            if (res && res.errCode === 0) {
              console.log(res)
              this.gardens = res.list
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 获取列表数据
      getData() {
        let loading = this.$loading()
        this.$get(
          `/partyActivity?activityName=${this.activityName}&gardenId=${this.gardenId}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 新增党建活动
      add() {
        this.$router.push({
          name: 'partyActivityAdd',
          query: {
            flag: false
          }
        })
      },
      // 编辑党建活动
      edit(rowData) {
        this.$router.push({
          name: 'partyActivityAdd',
          query: {
            rowData: rowData,
            flag: true
          }
        })
      },
      // 删除党建活动
      deleteOne(id) {
        let loading = this.$loading()
        this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'warning'
          }).then(() => {
            this.$delete(`/partyActivity/` + id).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.getData()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getData()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getData()
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },

    },
  }
</script>

<style lang="scss">
</style>